var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6007 2.68506C10.7074 2.68506 5.93408 3.35173 5.93408 8.01839V22.0184C5.93408 24.5917 8.02742 26.6851 10.6007 26.6851L8.60075 28.6851V29.3517H24.6007V28.6851L22.6007 26.6851C25.1741 26.6851 27.2674 24.5917 27.2674 22.0184V8.01839C27.2674 3.35173 22.4941 2.68506 16.6007 2.68506ZM16.6007 5.35173C24.6007 5.35173 24.6007 6.95173 24.6007 8.01839H8.60075C8.60075 6.95173 8.60075 5.35173 16.6007 5.35173ZM24.6007 10.6851V14.6851H8.60075V10.6851H24.6007ZM22.6007 24.0184H10.6007C9.49408 24.0184 8.60075 23.1251 8.60075 22.0184V17.3517H24.6007V22.0184C24.6007 23.1251 23.7074 24.0184 22.6007 24.0184ZM16.6007 18.0184C15.1341 18.0184 13.9341 19.2184 13.9341 20.6851C13.9341 22.1517 15.1341 23.3517 16.6007 23.3517C18.0674 23.3517 19.2674 22.1517 19.2674 20.6851C19.2674 19.2184 18.0674 18.0184 16.6007 18.0184Z",
    fill: "#8385DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.2020cc970e9c80e0c3e83adce461b93c.svg";
export { ForwardRef as ReactComponent };